export default __webpack_public_path__ + "static/media/01 - ApeCoin.022e75e1.jpeg";